import { render, staticRenderFns } from "./TabScreen.vue?vue&type=template&id=7f04fb23&"
import script from "./TabScreen.vue?vue&type=script&lang=js&"
export * from "./TabScreen.vue?vue&type=script&lang=js&"
import style0 from "./TabScreen.vue?vue&type=style&index=0&id=7f04fb23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports